import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityInvitationsLinkGetAsyncSlice } from './get';

export const securityInvitationsLinkReducers = combineReducers({
	get: securityInvitationsLinkGetAsyncSlice.asyncReducers
});

export const securityInvitationsLinkWatchers = combineAllWatchers([
	securityInvitationsLinkGetAsyncSlice.asyncWatchers
]);
